module.exports = __webpack_public_path__ + "img/english_materials.acf4fea3.png";